import Moment from "moment";
import { useContext, useState } from "react";
import { useNavigate } from "react-router";
import { ReqTopLineCreate } from "../../../../api/site/ApiForTopLine";
import Button from "../../../../components/UI/Button/Button";
import DateTimePicker from "../../../../components/UI/DatePicker/DateTimePicker";
import Input from "../../../../components/UI/Input/Input";
import Radio from "../../../../components/UI/Input/Radio";
import classes from "../../MngCommon.module.css";
import { JwtTokenContext } from "../../../../store/JwtTokenProvider";

function MngSiteTopLineCreate(props) {
    const loginCtx = useContext(JwtTokenContext);

    const navigate = useNavigate();

    const backHandler = () => {
        navigate("/admin/site/main");
    };

    const [title, setTitle] = useState();
    const [subTitle, setSubTitle] = useState();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [exposeYnStatus, setExposeYnStatus] = useState("Y");
    const [newTap, setNewTap] = useState("Y");
    const [url, setUrl] = useState();

    const changeTitleHandler = (value) => {
        setTitle(value);
    };

    const changeSubTitleHandler = (value) => {
        setSubTitle(value);
    };

    const startDateHandler = (date) => {
        setStartDate(date);
    };

    const endDateHandler = (date) => {
        setEndDate(date);
    };

    const exposeYnRadioButton = (e) => {
        setExposeYnStatus(e.target.value);
    };

    const newTapRadioButton = (e) => {
        setNewTap(e.target.value);
    };

    const changeUrlHandler = (value) => {
        setUrl(value);
    };

    const createHandler = async (e) => {
        e.preventDefault();

        if (endDate < startDate) {
            alert("종료일보다 시작일이 클 수 없습니다.");
            return;
        }

        if (!title) {
            alert("배너타이틀을 입력해주세요.");
            return;
        }

        if (!subTitle) {
            alert("서브타이틀을 입력해주세요.");
            return;
        }

        if (!url) {
            alert("URL을 입력해주세요.");
            return;
        }

        const isTrue = window.confirm("메인 띠배너를 등록하시겠습니까?");
        if (isTrue) {
            try {
                const jsonData = {
                    expose_yn: exposeYnStatus === "Y" ? true : false,
                    title: title,
                    sub_title: subTitle,
                    url: url,
                    expose_s_date: Moment(startDate).format("YYYYMMDDHHmm"),
                    expose_e_date: Moment(endDate).format("YYYYMMDDHHmm"),
                    new_tap: newTap === "Y" ? true : false,
                };

                const response = await ReqTopLineCreate(jsonData);
                if (response.status === 200) {
                    alert("메인 띠배너가 등록되었습니다.");
                    backHandler();
                } else if (response.status === 409) {
                    alert("* 메인 띠배너는 1개만 노출 가능합니다.");
                } else {
                    alert("메인 띠배너 등록 실패");
                }
            } catch (error) {
                console.error("Error:", error);
            }
        } else {
            return;
        }
    };

    return (
        <section>
            <div className={classes.admin_contents}>
                <h3>메인 띠배너 관리 - 등록</h3>
                <div
                    className={`${classes.contents_wrap} ${classes.search_wrap} `}
                >
                    <div className={classes.admin_table_wrap}>
                        <table>
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "30%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={2}>
                                        {Moment(new Date()).format(
                                            "YYYY-MM-DD"
                                        )}
                                    </td>
                                    <th>등록자</th>
                                    <td>{loginCtx.decodedToken.jti}</td>
                                </tr>
                                <tr>
                                    <th>노출여부</th>
                                    <td colSpan={4}>
                                        <div className={classes.radio_wrap}>
                                            <Radio
                                                value="Y"
                                                title="노출"
                                                name="rad_01"
                                                id="rad_01_01"
                                                checked={exposeYnStatus === "Y"}
                                                onChange={exposeYnRadioButton}
                                            />
                                            <Radio
                                                value="N"
                                                title="미노출"
                                                name="rad_01"
                                                id="rad_01_02"
                                                checked={exposeYnStatus === "N"}
                                                onChange={exposeYnRadioButton}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>노출기간</th>
                                    <td colSpan={4}>
                                        <div className={classes.date_pick_row}>
                                            <DateTimePicker
                                                id="start_date"
                                                onChange={startDateHandler}
                                                value={startDate}
                                            />
                                            <em>~</em>
                                            <DateTimePicker
                                                id="end_date"
                                                onChange={endDateHandler}
                                                value={endDate}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>배너타이틀</th>
                                    <td colSpan={4}>
                                        <Input
                                            className="admin_st"
                                            onChange={changeTitleHandler}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>서브타이틀</th>
                                    <td colSpan={4}>
                                        <Input
                                            className="admin_st"
                                            onChange={changeSubTitleHandler}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2}>링크</th>
                                    <th>타겟</th>
                                    <td colSpan={3}>
                                        <div className={classes.radio_wrap}>
                                            <Radio
                                                value="Y"
                                                title="자창"
                                                name="rad_02"
                                                id="rad_02_01"
                                                checked={newTap === "N"}
                                                onChange={newTapRadioButton}
                                            />
                                            <Radio
                                                value="N"
                                                title="새창"
                                                name="rad_02"
                                                id="rad_02_02"
                                                checked={newTap === "Y"}
                                                onChange={newTapRadioButton}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>URL</th>
                                    <td colSpan={3}>
                                        <Input
                                            className="admin_st"
                                            onChange={changeUrlHandler}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={classes.bottom_btn_wrap}>
                            <Button
                                className="secondary sm"
                                onClick={createHandler}
                            >
                                등록
                            </Button>
                            <Button className="border sm" onClick={backHandler}>
                                목록
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MngSiteTopLineCreate;
